import { format, fromUnixTime } from "date-fns";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Button } from "shards-react";
import * as firebase from "firebase/app";

const mapState = (state) => ({
  profile: state.firebase.profile,
  loading: state.async.loading,
});

export class ComplaintListItem extends Component {
  constructor(props) {
    super(props);
    this.state = { date: new Date().toDateString() };
  }

  checkStatus = (status) => {
    switch (status) {
      case "open":
        return <div className="pill ticket-open caption">Open</div>;

      case "processing":
        return <div className="pill ticket-processing caption">Processing</div>;

      case "closed":
        return <div className="pill ticket-closed caption">Closed</div>;
      case "cancelled":
        return <div className="pill ticket-closed caption">Cancelled</div>;

      case "overdue":
        return <div className="pill ticket-overdue caption">Overdue</div>;

      default:
        return <div className="pill ticket-open caption">Open</div>;
    }
  };

  componentDidMount() {
    if (this.props.complaint?.created) {
      let date = "";

      if (this.props.complaint?.created._seconds) {
        let currentDate = new Date(this.props.complaint?.created._seconds);
        date = currentDate.toDateString();
      } else if (
        this.props.complaint?.created instanceof firebase.firestore.Timestamp
      ) {
        date = format(this.props.complaint?.created.toDate(), "dd MMM yyyy");
      }

      if (this.props.archive) {
        date = this.props.complaint?.closedBy?.date
          ? format(this.props.complaint?.closedBy?.date.toDate(), "dd MMM yyyy")
          : this.props.complaint?.status === "cancelled" ? format(this.props.complaint?.lastEdited.date.toDate(),"dd MMM yyyy") :  "Date not Found";
      }
      this.setState({ date: date });
    }
  }

  render() {
    const { complaint, history, profile } = this.props;

    return (
      <Fragment>
        <td className="caption ">
          {this.state.date} {complaint.closedBy?.name}
        </td>
        <td className="text-capitalize caption text-break">{complaint.id}</td>
        <td className="text-lowercase caption text-break titleCase">
          {complaint.companyName || ""}
        </td>

        {profile && profile.role === "complainant" ? (
          <td className="caption titleCase">{complaint.agent.displayName}</td>
        ) : (
          <Fragment>
            <td className="caption titleCase text-break">
              {complaint.complainant.name}
            </td>
            <td className="caption text-break">
              {complaint.complainant.email}
            </td>
          </Fragment>
        )}
        {profile && profile.role === "manager" ? (
          <td className="caption titleCase">{complaint.agent.displayName}</td>
        ) : null}

        <td className="text-capitalize caption">
          {complaint.sectors && complaint.sectors[0]}
        </td>
        <td className="text-capitalize caption">
          {complaint.categories && complaint.categories[0]}
        </td>
        <td>{complaint.complaintType || "-"}</td>
        <td className="text-capitalize text-center caption">
          {complaint.cancelled ? (
            <div className="pill ticket-closed caption">Cancelled</div>
          ) : (
            this.checkStatus(complaint.status)
          )}
        </td>
        <td className="text-center  d-flex  py-2 justify-content-center">
          <Button
            outline
            onClick={() => {
              history.push(`/dashboard/complaintDetails/${complaint.id}`);
            }}
          >
            View
          </Button>
        </td>
      </Fragment>
    );
  }
}

export default compose(connect(mapState))(ComplaintListItem);
